import { render, staticRenderFns } from "./TableByColumn.vue?vue&type=template&id=4990890e&scoped=true"
import script from "./TableByColumn.vue?vue&type=script&lang=js"
export * from "./TableByColumn.vue?vue&type=script&lang=js"
import style0 from "./TableByColumn.vue?vue&type=style&index=0&id=4990890e&prod&lang=scss&scoped=true"
import style1 from "./TableByColumn.vue?vue&type=style&index=1&id=4990890e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4990890e",
  null
  
)

export default component.exports